/**
 * Normalizes a URL by removing trailing "#" character
 * This prevents navigation issues when comparing URLs that may have hash fragments
 *
 * @param url - The URL string to normalize (can be null)
 * @returns The normalized URL string, or empty string if input is null/undefined
 *
 * @example
 * normalizeUrl('https://example.com/page#') // returns 'https://example.com/page'
 * normalizeUrl('https://example.com/page') // returns 'https://example.com/page'
 * normalizeUrl(null) // returns ''
 */
export const normalizeUrl = (url: string | null): string => {
  if (!url) return '';
  return url.endsWith('#') ? url.slice(0, -1) : url;
};
